import React from 'react'
let PropTypes = React.PropTypes
// Componentes
import HeaderConFiltro from '../components/shared/HeaderConFiltro.jsx'
import {RowPublicadoCompleto} from './RowPublicado.jsx'
// CSS
import * as css from './ProgramacionPublicada.css'

export class TablaPublicadosCompleta extends React.Component{
    constructor(props){
        super(props)
        this.state = {
        }
    }
    render() {
        let totalInventarios = this.props.inventarios.length
        return (
            <div className="col-md-12">
                <div className="panel panel-default">
                    <div className="panel-body">
                        <TablaPublicadosTodo
                            filtros={this.props.filtros}
                            actualizarFiltro={this.props.actualizarFiltro}
                        >
                            {_.range(0, totalInventarios).map(index=>{
                                let inventario = this.props.inventarios[index]
                                return <RowPublicadoCompleto
                                    key={index}
                                    index={index}
                                    inventario={inventario}
                                    correlativo={''+(index+1)}
                                />
                            })}
                        </TablaPublicadosTodo>
                    </div>
                </div>
            </div>
        )
    }
}
TablaPublicadosCompleta.contextTypes = {
}
let TablaPublicadosTodo = ({children, filtros, actualizarFiltro}) =>
    <table className={"table table-condensed table-bordered "+css.tableFixed}>
        <colgroup>
            <col className={css.colIndex}/>
            <col className={css.colFecha}/>
            <col className={css.colCliente}/>
            <col className={css.colCeco}/>
            <col className={css.colRegion}/>
            <col className={css.colComuna}/>
            <col className={css.colTienda}/>
            <col className={css.colDireccion}/>
            <col className={css.colStock}/>
            <col className={css.colDotacion}/>
            <col className={css.colTurno}/>
            <col className={css.colLider}/>
            <col className={css.colLider}/>
            <col className={css.colHora}/>
            <col className={css.colHora}/>
            <col className={css.colNomina}/>
            <col className={css.colEstadoNomina}/>
        </colgroup>
        <thead>
        <tr>
            <th className={css.thIndex}>#</th>
            <th className={css.thFecha}>FECHA</th>
            <th className={css.thCliente}>
                <HeaderConFiltro
                    nombre='CL'
                    filtro={filtros.filtroClientes || []}
                    actualizarFiltro={actualizarFiltro.bind(this, 'filtroClientes')}
                    busquedaExacta={true}
                />
            </th>
            <th className={css.thCeco}>
                <HeaderConFiltro
                    nombre='CE'
                    filtro={filtros.filtroCeco || []}
                    actualizarFiltro={actualizarFiltro.bind(this, 'filtroCeco')}
                    busquedaExacta={true}
                />
            </th>
            <th className={css.thRegion}>
                <HeaderConFiltro
                    nombre='RG'
                    filtro={filtros.filtroRegiones || []}
                    actualizarFiltro={actualizarFiltro.bind(this, 'filtroRegiones')}
                    busquedaExacta={true}
                />
            </th>
            <th className={css.thComuna}>
                <HeaderConFiltro
                    nombre='COMUNA'
                    filtro={filtros.filtroComunas || []}
                    actualizarFiltro={actualizarFiltro.bind(this, 'filtroComunas')}
                    busquedaExacta={true}
                />
            </th>
            <th className={css.thTienda}>TIENDA</th>
            <th className={css.thDireccion}>DIR</th>
            <th className={css.thStock}>STOCK</th>
            <th className={css.thDotacion}>DOT</th>
            <th className={css.thTurno}>TURNO</th>
            <th className={css.thLider}>
                <HeaderConFiltro
                    nombre='LIDER'
                    filtro={filtros.filtroLideres || []}
                    actualizarFiltro={actualizarFiltro.bind(this, 'filtroLideres')}
                />
            </th>
            <th className={css.thLider}>SUPERVISOR</th>
            <th className={css.thHora}>
                <HeaderConFiltro
                    nombre="LIDER"
                    filtro={filtros.filtroHoraLider || []}
                    actualizarFiltro={actualizarFiltro.bind(this, 'filtroHoraLider')}
                />
            </th>
            <th className={css.thHora}>EQUIPO</th>
            <th className={css.thNomina}>
                <HeaderConFiltro
                    nombre='NOMINA'
                    filtro={filtros.filtroNominas || []}
                    actualizarFiltro={actualizarFiltro.bind(this, 'filtroNominas')}
                />
            </th>
            <th className={css.thEstadoNomina}>
                <HeaderConFiltro
                    nombre=''
                    filtro={filtros.filtroNominasEstado || []}
                    actualizarFiltro={actualizarFiltro.bind(this, 'filtroNominasEstado')}
                    busquedaExacta={false}
                />
            </th>
        </tr>
        </thead>
        <tbody>
        {children}
        </tbody>
    </table>




// WEBPACK FOOTER //
// ./frontEnd/inventarios/TablaPublicados.jsx